import React from "react";
import { Container, Alert, Button } from "react-bootstrap";

/**
 * Error Boundary Component
 * Best Practice from .agent/skills/react-expert #39
 * Catches JavaScript errors anywhere in child component tree
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so next render shows fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details
    console.error("ErrorBoundary caught an error:", error, errorInfo);
    this.setState({
      error,
      errorInfo,
    });

    // You can also log to an error reporting service here
    // logErrorToService(error, errorInfo);
  }

  handleReset = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null,
    });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      // Fallback UI
      return (
        <Container className="py-5">
          <Alert variant="danger" className="text-center">
            <Alert.Heading>
              <i className="bi bi-exclamation-triangle-fill me-2"></i>
              Đã xảy ra lỗi
            </Alert.Heading>
            <p>
              Xin lỗi, có lỗi xảy ra trong quá trình hiển thị trang. Vui lòng
              thử tải lại trang.
            </p>
            {process.env.NODE_ENV === "development" && this.state.error && (
              <details className="mt-3 text-start">
                <summary style={{ cursor: "pointer" }}>
                  Chi tiết lỗi (Development)
                </summary>
                <pre className="mt-2 p-3 bg-light rounded">
                  {this.state.error.toString()}
                  {this.state.errorInfo?.componentStack}
                </pre>
              </details>
            )}
            <hr />
            <Button
              variant="primary"
              onClick={this.handleReset}
              aria-label="Tải lại trang"
            >
              <i className="bi bi-arrow-clockwise me-2"></i>
              Tải Lại Trang
            </Button>
          </Alert>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
